import React, { Fragment, FunctionComponent } from "react";
import styles from "./Button3.module.scss";

import Anchor from "components/Anchor/Anchor";
import ButtonProps from "components/Button/ButtonProps.interface";
import combineClasses from "helpers/combine-classes";
import useAnimation from "blocks/hooks/useAnimation";

const Button3: FunctionComponent<ButtonProps> = (props) => {
    const { animationClasses } = useAnimation(styles, "animation1");

    return (
        <Fragment>
            {typeof(props.onClick) !== "undefined" ? (
                <button style={props.style} id={props.id} title={props.title} className={combineClasses(styles.button, animationClasses, props.className)} onClick={props.onClick}>
                    <span className={styles.adjustment}>
                        {props.children}
                    </span>
                </button>
            ) : null}

            {typeof(props.onClick) === "undefined" ? (
                <Anchor style={props.style} id={props.id} title={props.title} className={combineClasses(styles.button, animationClasses, props.className)} to={props.to}>
                    <span className={styles.adjustment}>
                        {props.children}
                    </span>
                </Anchor>
            ) : null}
        </Fragment>
    );
};

export default Button3;